import { required, minLength, sameAs } from 'vuelidate/lib/validators'
import { accountService } from '../../services/AccountService';

export default {
    name: 'PasswordReset',
    data: () => {
        return {
            loading: true,
            errors: '',
            credentials: {}
        }
    },
    validations: {
        credentials: {
            NewPassword: {
                required,
                minLength: minLength(6)
            },
            ConfirmPassword: {
                required,
                minLength: minLength(6),
                //sameAsNewPassword: sameAs('NewPassword')
            }
        }
    },
    computed: {
        isValid() {
            return !this.$v.$anyError
        }
    },
    created() {
        var model = this;

        model.credentials.id = model.$route.params.id;
        model.credentials.Token = model.$route.query.token;
        model.credentials.UserName = model.$route.params.userName;
        model.credentials.NewPassword = '';
        model.credentials.ConfirmPassword = '';

        model.loading = false;
    },
    methods: {
        validate: function () {
            this.$v.$touch();
            this.$nextTick(() => this.findFirstError());

            return this.isValid;
        },
        chkState: function (val) {
            const field = this.getDescendantProp(this.$v, val);

            return !field.$dirty || !field.$invalid
        },
        //
        handleSubmit() {
            var model = this;

            if (!model.validate())
                return;

            accountService.resetPassword(model.credentials)
                .finally(() => this.loading = false)
                .then(response => {
                    this.loading = true;

                    //this.$router.push({ name: 'Home' });
                    this.$router.push({ name: 'Login', query: { returnUrl: '/', userName: response.data } });
                })
                .catch(e => {
                    //showErrorNotification(e);
                });
        }
    }
}
